module.exports = __webpack_public_path__ + "715ba6c3e7194b15d5015ddd3f37b77c.png";